import React from 'react';
import AppSelect from '../util/AppSelect';
import SettingsBlock from '../util/SettingsBlock';

interface TasksProps {
  staticCountrySelect: any,
  handleChangeSelected: any,
  setStaticCountrySelect: any,
  staticCountry: any,
  staticCurrencySelect: any,
  setStaticCurrencySelect: any,
  staticCurrency: any,
  staticDateSelect: any,
  setStaticDateSelect: any,
  staticDate: any,
  staticNumberSelect: any,
  setStaticNumberSelect: any,
  staticNumber: any,
  staticLanguageSelect: any,
  setStaticLanguageSelect: any,
  staticLanguage: any,
  staticTimeZoneSelected: any,
  handleTimeZoneChange: any,
  staticTimeZone: any,
  userTimeZone: any,
  utcOffset: any,
  unit: any,
  setUnit: any
}

const ROW: React.CSSProperties = { display: 'flex', flexDirection: 'column', marginBottom: 12 };
const LBL: React.CSSProperties = { fontSize: 10, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--text-color-calendar-week)', marginBottom: 4 };

const Other: React.FC<TasksProps> = ({
  staticCountrySelect, handleChangeSelected, setStaticCountrySelect, staticCountry,
  staticCurrencySelect, setStaticCurrencySelect, staticCurrency,
  staticDateSelect, setStaticDateSelect, staticDate,
  staticNumberSelect, setStaticNumberSelect, staticNumber,
  staticLanguageSelect, setStaticLanguageSelect, staticLanguage,
  staticTimeZoneSelected, handleTimeZoneChange, staticTimeZone,
  userTimeZone, utcOffset,
  unit, setUnit,
}) => (
  <div>
    <SettingsBlock title="Region & Language">
      <div style={{ padding: '12px 16px' }}>
        <div style={ROW}>
          <label style={LBL}>Country</label>
          <AppSelect
            style={{ width: 300 }}
            value={staticCountrySelect || null}
            onChange={v => handleChangeSelected(v, 'staticCountryId', setStaticCountrySelect)}
            placeholder="Select country…"
            searchable
            options={staticCountry.map((c: any) => ({ value: c.id, label: c.name }))}
          />
        </div>
        <div style={ROW}>
          <label style={LBL}>Currency</label>
          <AppSelect
            style={{ width: 300 }}
            value={staticCurrencySelect || null}
            onChange={v => handleChangeSelected(v, 'staticCurrencyId', setStaticCurrencySelect)}
            placeholder="Select currency…"
            searchable
            options={staticCurrency.map((c: any) => ({ value: c.id, label: c.name }))}
          />
        </div>
        <div style={ROW}>
          <label style={LBL}>Language</label>
          <AppSelect
            style={{ width: 300 }}
            value={staticLanguageSelect || null}
            onChange={v => handleChangeSelected(v, 'staticLanguageId', setStaticLanguageSelect)}
            placeholder="Select language…"
            options={staticLanguage.map((l: any) => ({ value: l.id, label: l.name }))}
          />
        </div>
        <div style={ROW}>
          <label style={LBL}>Time Zone</label>
          <AppSelect
            style={{ width: 300 }}
            value={staticTimeZoneSelected || null}
            onChange={v => handleTimeZoneChange({ target: { value: v } })}
            placeholder="Select time zone…"
            searchable
            options={staticTimeZone.map((t: any) => ({ value: t.id, label: `${t.name} (UTC ${t.utc_offset})` }))}
          />
          {userTimeZone && utcOffset && (
            <div style={{ fontSize: 10, color: 'var(--text-color-calendar-week)', marginTop: 4 }}>
              Your Time Zone: {userTimeZone} {utcOffset}
            </div>
          )}
        </div>
      </div>
    </SettingsBlock>

    <SettingsBlock title="Formats" defaultOpen={false}>
      <div style={{ padding: '12px 16px' }}>
        <div style={ROW}>
          <label style={LBL}>Date Format</label>
          <AppSelect
            style={{ width: 300 }}
            value={staticDateSelect || null}
            onChange={v => handleChangeSelected(v, 'staticDateId', setStaticDateSelect)}
            placeholder="Select date format…"
            options={staticDate.map((d: any) => ({ value: d.id, label: d.format_string }))}
          />
        </div>
        <div style={ROW}>
          <label style={LBL}>Number Format</label>
          <AppSelect
            style={{ width: 300 }}
            value={staticNumberSelect || null}
            onChange={v => handleChangeSelected(v, 'staticNumberId', setStaticNumberSelect)}
            placeholder="Select number format…"
            options={staticNumber.map((n: any) => ({ value: n.id, label: n.name }))}
          />
        </div>
        <div style={ROW}>
          <label style={LBL}>Distance Unit</label>
          <AppSelect
            style={{ width: 300 }}
            value={unit || null}
            onChange={v => handleChangeSelected(v, 'unit', setUnit)}
            placeholder="Select unit…"
            options={[
              { value: 'km', label: 'Kilometers' },
              { value: 'mi', label: 'Miles' },
            ]}
          />
        </div>
      </div>
    </SettingsBlock>
  </div>
);

export default Other;
